import {PermissionRes} from './account.contracts';
import {UserDetailsMinRes} from './user.contract';

export class RoleCreateReq {
    name!: string;
    description!: string;
}
export class RoleUpdateReq {
    id!: number;
    name!: string;
    description!: string;
    permissionIds!: number[];

}
export class RoleMinRes {
    id!: number;
    name!: string;
    description!: string;
    sumPermissions!:number;
    isSystemRole!: boolean;
}

export class RoleRes {
    id!: number;
    name!: string;
    description!: string;
    sumPermissions!:number;
    isSystemRole!: boolean;
    permissions:PermissionRes[] =[]
    user:UserDetailsMinRes[] = []

    constructor(id: number = 0, name: string = '', description: string = '') {
        this.id = id;
        this.name = name;
        this.description = description;
    }

    static compare(a: RoleRes, b: RoleRes): boolean {
        return a.id === b.id;
    }
}
